// extracted by mini-css-extract-plugin
export default {"termCardListSubHeader":"TermCardList_termCardListSubHeader__qwy5-","illustration":"TermCardList_illustration__PI3Hx"};